/**
 * Classe com funções genéricas para as time window
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * Date: 04/11/2013
 * Time: 09:17
 *
 */


Greenmile.TimeWindow = Greenmile.TimeWindow || {};

Greenmile.TimeWindow.GeneralFunctions = function () {

    this.validateTimeWindow = function (allowSubmit, entity) {

        var error = null;

        try {

            var tab = App.Forms[entity].form.fields;

            var openTime          = null,
                tw1Open           = null,
                tw2Open           = null,
                tw1Close          = null,
                tw2Close          = null,
                closeTime         = null,
                timeValidate      = null,
                openTimeSelector  = tab.openTime,
                tw1OpenSelector   = tab.tw1Open,
                tw1CloseSelector  = tab.tw1Close,
                tw2OpenSelector   = tab.tw2Open,
                tw2CloseSelector  = tab.tw2Close,
                closeTimeSelector = tab.closeTime,
                resource          = null;

            openTime = openTimeSelector.input.value;
            tw1Open = tw1OpenSelector.input.value;
            tw1Close = tw1CloseSelector.input.value;
            tw2Open = tw2OpenSelector.input.value;
            tw2Close = tw2CloseSelector.input.value;
            closeTime = closeTimeSelector.input.value;

            timeValidate = new Monet.Date.GeneralFunctions();

            var appendErrorMessage = function (resourceKey) {
                allowSubmit.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(resourceKey));

            };

            var tw1OpenIsOk = function () {

                if (tw1Open === '') {
                    return true;
                }

                var isGreaterThanOpenWindow = timeValidate.endHourIsGreaterOrEqualThanBeginningHour(openTime, tw1Open);
                var isLessThanTw1Close = timeValidate.endHourIsGreaterThanStartHour(tw1Open, tw1Close);
                var isLessThanCloseTime = timeValidate.endHourIsGreaterThanStartHour(tw1Open, closeTime);

                if (isGreaterThanOpenWindow && isLessThanTw1Close && isLessThanCloseTime) {
                    return true;
                }

                return false;

            };

            var tw1CloseIsOk = function () {

                if (tw1Close === '') {
                    return true;
                }

                var isGreaterThanOpenWindow = timeValidate.endHourIsGreaterThanStartHour(openTime, tw1Close);
                var isGreaterThanTw1Open = timeValidate.endHourIsGreaterThanStartHour(tw1Open, tw1Close);
                var isLessThanCloseTime = timeValidate.endHourIsGreaterOrEqualThanBeginningHour(tw1Close, closeTime);

                if (tw2Open !== '') {

                    var isLessOrEqualTw2Open = timeValidate.endHourIsGreaterThanStartHour(tw1Close, tw2Open);

                    if (isGreaterThanOpenWindow && isGreaterThanTw1Open && isLessOrEqualTw2Open && isLessThanCloseTime) {
                        return true;
                    }
                }

                if (isGreaterThanOpenWindow && isGreaterThanTw1Open && isLessThanCloseTime) {
                    return true;
                }

                return false;

            };

            var tw2OpenIsOk = function () {

                if (tw2Open !== '') {

                    var isGreaterThanOpenWindow = timeValidate.endHourIsGreaterOrEqualThanBeginningHour(openTime, tw2Open);
                    var isGreaterOrEqualThanTw1Close = timeValidate.endHourIsGreaterThanStartHour(tw1Close, tw2Open);
                    var isLessTw2Close = timeValidate.endHourIsGreaterThanStartHour(tw2Open, tw2Close);
                    var isLessThanCloseTime = timeValidate.endHourIsGreaterThanStartHour(tw2Open, closeTime);

                    if (isGreaterThanOpenWindow && isGreaterOrEqualThanTw1Close && isLessTw2Close && isLessThanCloseTime) {
                        return true;
                    }

                    return false;

                }

                return true;

            };

            var tw2CloseIsOk = function () {

                if (tw2Open !== '') {

                    var isGreaterThanOpenWindow = timeValidate.endHourIsGreaterThanStartHour(openTime, tw2Close),
                        isGreaterThanTw2Open    = timeValidate.endHourIsGreaterThanStartHour(tw2Open, tw2Close),
                        isLessThanCloseTime      = timeValidate.endHourIsGreaterOrEqualThanBeginningHour(tw2Close, closeTime);

                    if (isGreaterThanOpenWindow && isGreaterThanTw2Open && isLessThanCloseTime) {
                        return true;
                    }

                    return false;

                }

                return true;

            };

            var timeCloseIsOk = function () {

                if (closeTime === '') {
                    return true;
                }

                var isGreaterThanOpenWindow = timeValidate.endHourIsGreaterThanStartHour(openTime, closeTime),
                    isGreaterThanTw1Open    = timeValidate.endHourIsGreaterThanStartHour(tw1Open, closeTime),
                    isGreaterThanTw1Close   = timeValidate.endHourIsGreaterOrEqualThanBeginningHour(tw1Close, closeTime);

                if (tw2Open !== '' && tw2Close !== '') {

                    var isGreaterThanTw2Open  = timeValidate.endHourIsGreaterThanStartHour(tw2Open, closeTime),
                        isGreaterThanTw2Close = timeValidate.endHourIsGreaterOrEqualThanBeginningHour(tw2Close, closeTime);

                    if (isGreaterThanOpenWindow && isGreaterThanTw1Open && isGreaterThanTw1Close && isGreaterThanTw2Open && isGreaterThanTw2Close) {
                        return true;
                    }

                    return false;

                }

                if (isGreaterThanOpenWindow && isGreaterThanTw1Open && isGreaterThanTw1Close) {
                    return true;
                }

                return false;

            };

            if (!tw1OpenIsOk()) {

                appendErrorMessage("LocationOverrideTW.messageError.tw1OpenTimeError");

            }

            if (!tw1CloseIsOk()) {

                appendErrorMessage("LocationOverrideTW.messageError.tw1CloseTimeError");

            }

            if (!tw2OpenIsOk()) {

                appendErrorMessage("LocationOverrideTW.messageError.tw2OpenTimeError");

            }

            if (!tw2CloseIsOk()) {

                appendErrorMessage("LocationOverrideTW.messageError.tw2CloseError");

            }

            if (!timeCloseIsOk()) {

                appendErrorMessage("LocationOverrideTW.messageError.timeCloseError");

            }

            if (allowSubmit.errorMessages.length > 0) {

                allowSubmit.status = false;

            }

            return allowSubmit;


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error validate times on time window.");
            error.console();

        }
    };

    this.getTimeWindow = function (location) {

        var arrayTimeWindow = [];
        var timeWindowType;

        if (location.timeWindowType) {
            timeWindowType = location.timeWindowType.timeWindowTypeDays;
        }

        var locationOverrideTimeWindows = location.locationOverrideTimeWindows;

        var keyIsDay = function (key) {

            var isDay;

            switch (key) {

                case 'sunday':
                case 'monday':
                case 'tuesday':
                case 'wednesday':
                case 'thursday':
                case 'friday':
                case 'saturday':
                    isDay = true;
                    break;
                default :
                    isDay = false;

            }

            return isDay;

        };

        var verifyIfExistsTimeWindow = function (day) {

            var dayExists = false;

            for (var key in locationOverrideTimeWindows) {

                var overrideTw = locationOverrideTimeWindows[key];

                if (overrideTw[day] === true) {
                    dayExists = true;
                    break;
                }

            }

            return dayExists;

        };

        var formatTimeWindow = function (timewindow) {

            var days = [];
            var ocTime;
            var tw1 = "";
            var tw2 = "";
            var timeWindows;

            for (var key in timewindow) {

                var isDay = keyIsDay(key);
                var existInTimeWindow = false;

                if (isDay && timewindow.isTypeDay) {

                    existInTimeWindow = verifyIfExistsTimeWindow(key);

                }

                if (isDay && !existInTimeWindow && timewindow[key]) {

                    days.push('Greenmile.Data.WeekDays.' + key.substr(0, 3));

                }

            }

            var emptyValue = '--:--';
            ocTime = (timewindow.openTime || emptyValue) + " - " + (timewindow.closeTime || emptyValue);

            if (timewindow.tw1Open && timewindow.tw1Close) {
                tw1 = (timewindow.tw1Open || emptyValue) + " " + (timewindow.tw1Close || emptyValue);
            }

            if (timewindow.tw2Open && timewindow.tw2Close) {
                tw2 = " - " + (timewindow.tw2Open || emptyValue) + " " + (timewindow.tw2Close || emptyValue);
            }

            timeWindows = tw1 + tw2;

            return {
                days: days,
                timeWindow: timeWindows,
                openClose: ocTime
            };

        };

        var getTimeWindowTypeDays = function () {

            for (var item in timeWindowType) {

                var timeWindow = timeWindowType[item];
                var result;

                timeWindow.isTypeDay = true;
                result = formatTimeWindow(timeWindow);

                if (result.days.length) {
                    arrayTimeWindow.push(result);
                }

            }
        };

        var getOverrideTimeWindow = function () {

            for (var overrideItem in locationOverrideTimeWindows) {

                arrayTimeWindow.push(formatTimeWindow(locationOverrideTimeWindows[overrideItem]));

            }

        };

        getTimeWindowTypeDays();
        getOverrideTimeWindow();

        return arrayTimeWindow;

    };

    this.getTimeWindowObject = function(location) {
      const timeWindowTypeDays =  location?.timeWindowType?.timeWindowTypeDays;
      const locationOverrideTimeWindows = location?.locationOverrideTimeWindows;
      const hasOnlyOverrideTimeWindows = !timeWindowTypeDays?.length && locationOverrideTimeWindows?.length;

      const convertTwToTime = time =>
        time ?
        Monet.Format.Time.formatToLocale(Monet.Format.Time.parse(time)) :
        '--:--';

      const formatTimeWindow = (timewindow) => ({
        timeWindow: {
          tw1: {
            open: convertTwToTime(timewindow.tw1Open),
            close: convertTwToTime(timewindow.tw1Close)
          },
          tw2: {
            open: convertTwToTime(timewindow.tw2Open),
            close: convertTwToTime(timewindow.tw2Close),
          }
        },
        openClose: {
          open: convertTwToTime(timewindow.openTime),
          close: convertTwToTime(timewindow.closeTime)
        }
      });

      if (hasOnlyOverrideTimeWindows) {
        return locationOverrideTimeWindows.map((time) => {
          return {
            actual: formatTimeWindow(time),
            override: formatTimeWindow(time)
          }
        });
      }

      const arrayTimeWindow = timeWindowTypeDays?.map((time, index) => {
        const hasOverrideTw = locationOverrideTimeWindows && !!locationOverrideTimeWindows[index];

        if (hasOverrideTw) {
          return {
            override: formatTimeWindow(locationOverrideTimeWindows[index]),
            actual: formatTimeWindow(time)
          }
        }

        return {
          actual: formatTimeWindow(time)
        }
      }) ?? [];

      return arrayTimeWindow;
    }

};
